import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type CenteredCtaProps = CtaShellProps

export function CenteredCta(props: CenteredCtaProps) {
	return <CtaShell {...props} placement={props.placement ?? "between-section"} layout="centered" />
}